import { MonitorAlertFullDto } from '../types';
import { useCurrentTime } from '@/lib/time';
import { useContextualTimeZone } from '@/components/TimezoneProvider';
import { EventTimeDisplay } from './EventTimeDisplay';

export default function BaseEventInfo({ alertData }: { alertData: MonitorAlertFullDto }) {
  const currentTime = useCurrentTime();

  const { timeZone, getUTCOffset} = useContextualTimeZone();

  return (
    <>
      <div className="flex items-center gap-3 border-b border-[#2E3835] p-4 text-xs">
        <img src="/icon/map.svg" alt="menu" className="w-4" />
        <div>
          <p className="text-white">
            <strong>{alertData.project?.address?.addressLine1 || 'Unknown Address'}</strong>
          </p>
          <p className="text-gray-400">
            {[alertData.project?.address?.addressLine2, alertData.project?.address?.region].find(
              Boolean
            ) || 'Unknown Area'}
            {alertData.project?.address?.city && `, ${alertData.project?.address?.city}`}
            {alertData.project?.address?.country && `, ${alertData.project?.address?.country}`}
            {alertData.project?.address?.postCode && `, ${alertData.project?.address?.postCode}`}
          </p>
        </div>
      </div>

      <div className="flex flex-col text-xs">
        <EventTimeDisplay
          label="Event started:"
          date={alertData.occurred ?? null}
          compactDisplay={alertData.closedAt != null}
          utcOffsetString={getUTCOffset() ?? ''}
          timeZone={timeZone}
        />
        {alertData.closedAt && (
          <EventTimeDisplay
            label="Event closed:"
            date={alertData.closedAt ?? null}
            compactDisplay={true}
            utcOffsetString={getUTCOffset() ?? ''}
            timeZone={timeZone}
          />
        )}
      </div>
      <div className="flex flex-col text-xs">

      {!alertData.closedAt && timeZone && (
        <EventTimeDisplay
          label="Current time at site:"
          date={currentTime}
          compactDisplay={false}
          utcOffsetString={getUTCOffset() ?? ''}
          timeZone={timeZone}
        />
      )}
      </div>
    </>
  );
}
